import React from 'react';
import { IconProps } from '.';

const SvgCamera = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M15.31 3.25H8.69l-2 2H1.25v15.5h21.5V5.25h-5.44l-2-2Zm-.62 1.5 2 2h4.56v12.5H2.75V6.75h4.56l2-2h5.38Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 15.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 1.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCamera;
